import strings from '@/strings'
import utils from './utils'
import errorhandler from '@/utils/errorhandler.js'

export default {
  async downloadFile(serviceMethod, defaultFileName, params, dispatch) {
    try {
      dispatch('setIsDownloadingFile', true)

      const {
        maxTimeToWait,
        statusProcessed,
        initialRetry,
        initialSumTimeToWait
      } = strings.downloadFile

      const exportId = utils.uuidv4()

      const initDownload = async (retries = initialRetry, sumTimeToWait = initialSumTimeToWait) => {
        const requestParams = params ? { ...params, exportId } : { exportId }

        const response = await serviceMethod(requestParams)

        if (response.status === statusProcessed) {
          dispatch('setIsDownloadingFile', false)

          let contentType = response.headers['content-type']
          let contentDisposition = response.headers['content-disposition']
          let fileName = contentDisposition ? utils.getFileName(contentDisposition) : defaultFileName

          let blob = new Blob([response.data], { type: contentType })
          utils.handleDownload(blob, fileName)
        } else {
          const result = await utils.exponentialBackoffProgress(retries, sumTimeToWait, maxTimeToWait)
          await utils.waitFor(result.timeToWait)
          return initDownload(retries + 1, result.newSumTimeToWait, result.progress)
        }
      }

      await initDownload()
    } catch (error) {
      dispatch('setIsDownloadingFile', false)
      errorhandler.handleError(error)
    }
  }
}
